// Client mirror of app/lib/chain_explorers.rb — mainnet explorers for pay-in
// chains. Lightning has no on-chain page; return null for BTCLN / unknown.

import { chainForAsset, RefundChain } from "./chainAddress";

type Explorer = {
  name: string;
  tx: (txid: string) => string;
  address: (address: string) => string;
};

const EXPLORERS: Record<Exclude<RefundChain, null>, Explorer> = {
  solana: {
    name: "Solscan",
    tx: (txid) => `https://solscan.io/tx/${encodeURIComponent(txid)}`,
    address: (a) => `https://solscan.io/account/${encodeURIComponent(a)}`
  },
  tron: {
    name: "Tronscan",
    tx: (txid) => `https://tronscan.org/#/transaction/${encodeURIComponent(txid)}`,
    address: (a) => `https://tronscan.org/#/address/${encodeURIComponent(a)}`
  },
  ethereum: {
    name: "Etherscan",
    tx: (txid) => `https://etherscan.io/tx/${encodeURIComponent(txid)}`,
    address: (a) => `https://etherscan.io/address/${encodeURIComponent(a)}`
  }
};

export const explorerForAsset = (assetCode: string): Explorer | null => {
  const chain = chainForAsset(assetCode);
  return chain ? EXPLORERS[chain] : null;
};

export const explorerTxUrl = (txid: string | null | undefined, assetCode: string): string | null => {
  if (!txid) return null;
  const explorer = explorerForAsset(assetCode);
  return explorer ? explorer.tx(txid) : null;
};

export const explorerAddressUrl = (
  address: string | null | undefined,
  assetCode: string
): string | null => {
  if (!address) return null;
  const explorer = explorerForAsset(assetCode);
  return explorer ? explorer.address(address) : null;
};

export const shortTxId = (txid: string, head = 16): string =>
  txid.length <= head ? txid : `${txid.slice(0, head)}…`;
